import { ComponentType, ReactNode } from 'react';
import { StandardInput } from '../../../components/forms';
import { AreaEntity, ResourceEntity } from '../../../types/game-document/';
import {
  CheckboxChangeEvent,
  InputChangeEvent,
  SwitchChangeEvent,
  TextAreaChangeEvent
} from '@progress/kendo-react-inputs';
import { EditorMode } from '../../../types/editor-mode';
import { AreaEditorFeature } from './area-editor-feature';
import { Algorithm } from '../../../types/algorithm';
import { AreaAlgorithmEvent } from '../../../types/game-document/area';
import RequiredFields from '../../../types/required-fields';

interface AreaEditorProps {
  editorMode: EditorMode;
  entity: AreaEntity;
  resources: ResourceEntity[];
  children?: ReactNode | undefined;
  requiredFields?: RequiredFields<AreaEntity>[];
  handleInputChange?: (event: InputChangeEvent | TextAreaChangeEvent) => void;
  handleAreaChange?: (
    key: string,
    value: string | Algorithm,
    type: 'entity' | 'algorithm'
  ) => void;
}

export const AreaEditor: ComponentType<AreaEditorProps> = ({
  editorMode,
  entity,
  resources,
  handleInputChange = () => {},
  requiredFields,
  handleAreaChange = () => {},
  ...props
}: AreaEditorProps) => {
  return (
    <>
      {editorMode === 'basic' && (
        <div className={'d-flex flex-row'}>
          <div className={'flex-column flex-fill'}>
            <StandardInput
              name={'titleResId'}
              label={'Title'}
              onChange={handleInputChange}
              validationMessage={
                requiredFields?.find((item) => item.name === 'titleResId')
                  ?.errorMessage
              }
            />
            <StandardInput
              name={'description'}
              label={'Description'}
              onChange={handleInputChange}
            />
          </div>
        </div>
      )}
      {editorMode === 'full' && (
        <AreaEditorFeature
          entity={entity}
          resources={resources}
          requiredFields={requiredFields}
          handleAlgorithmEventChange={(
            algorithm: Algorithm,
            type: AreaAlgorithmEvent
          ) => handleAreaChange(type, algorithm, 'algorithm')}
          handleInputChange={(
            e:
              | InputChangeEvent
              | TextAreaChangeEvent
              | CheckboxChangeEvent
              | SwitchChangeEvent
          ) =>
            handleAreaChange(e.target.name!, e.target.value as string, 'entity')
          }
        />
      )}

      {props.children}
    </>
  );
};
